const errors = {
    "TEST_NOT_VALID_BY_EMAIL": "Teste não disponível. Já foi gerada uma conta de teste anteriormente para você. Entre em contato com um representante.",
    "TEST_NOT_VALID_BY_PHONE": "Teste não disponível. Já foi gerada uma conta de teste anteriormente para você. Entre em contato com um representante.",
    "TEST_NOT_VALID_BY_USERNAME": "Teste não disponível. Já foi gerada uma conta de teste anteriormente para você. Entre em contato com um representante.",
    "LOGIN_OR_PASS_INVALID": "Desculpe, as credenciais que você está usando são inválidas.",
    "LOGIN_NOT_ACTIVE": "Seu acesso não está ativo no momento, por favor, entre em contato com o suporte",
    "OFFICE_NOT_ACTIVE": "Seu acesso não está ativo no momento, por favor, entre em contato com o suporte",
    "CLIENT_GENERAL_ERROR": "Ocorreu um erro ao gravar o cliente",
    "CLIENT_NO_DATA_TO_UPDATE":"Ops. Você não informou os novos dados do cliente."
}

export default (key) => {
    return errors[key] || key;
}


// WEBPACK FOOTER //
// ./src/js/services/getConstants.js